// eg 2021-04-09
// const getIsoToday = () => new Date().toISOString().slice(0, 10);

const minAge = 16;

const getIsoMaxDate = () => {
  const maxDate = new Date();
  maxDate.setFullYear(new Date().getFullYear() - minAge);
  return maxDate.toISOString().slice(0, 10);
};

const isoToNonStandardFormat = (iso = '') => iso.replace('-', '').replace('-', '');

// eg 20050409
// const getTodayNonStandardDateFormat = () => isoToNonStandardFormat(getIsoToday());
const getMaxDateNonStandardDateFormat = () => isoToNonStandardFormat(getIsoMaxDate());

const dateRegex = /^(-?(?:[1-9][0-9]*)?[0-9]{4})(1[0-2]|0[1-9])(3[01]|0[1-9]|[12][0-9])?$/;
const isYyyyMmDd = (yyyyMMdd = '') => yyyyMMdd.length === 8 && dateRegex.test(yyyyMMdd);
const isEmptyDate = (yyyyMMdd = '') => yyyyMMdd === '--' || yyyyMMdd === '';
const disallowedChars = '0123456789{}[]()<>,.?!”@£$%^&*;:|+=\\/';
const disallowedCharsArray = disallowedChars.split('');

const disallowedEmailChars = '!><$£(),#?|*';
const disallowedEmailCharsArray = disallowedEmailChars.split('');

export const allValidationConfig = {
  lipFirstName: {
    required: true,
    length: { min: 2, max: 30 },
    lettersApostrophesOnly: true,
  },
  lipLastName: {
    required: true,
    length: { min: 2, max: 30 },
    lettersApostrophesOnly: true,
  },
  phoneNumber_lipPersonalMobile: {
    required: true,
    digitsOnly: true,
    minMaxDigits: [8, 12],
  },
  lipPersonalEmail: {
    required: true,
    email: true,
    length: { min: 6, max: 75 },
  },

  phoneNumber_lipBusinessMobile: {
    required: false,
    digitsOnly: true,
    minMaxDigits: [8, 12],
  },
  lipBusinessMail: { required: false, email: true, length: { min: 6, max: 75 } },

  lipDateOfBirth: {
    required: true,
    isDate: true,
    minDate: '19000101',
    maxDate: getMaxDateNonStandardDateFormat(),
  },
  password: {
    required: true,
    length: { min: 8, minMessage: 'Password must be minimum 8 characters', max: 128 },
  },
  confirmPassword: { required: true, passwordsMustMatch: true },
};

const validators = {
  required: (fieldValue = '', isRequired) => {
    if (!fieldValue.trim() && isRequired) {
      return 'Required field';
    }
    return '';
  },
  length: (fieldValue = '', config = {}) => {
    if (fieldValue.trim().length < config.min) {
      return config.minMessage || 'Too short';
    }
    if (fieldValue.trim().length > config.max) {
      return config.maxMessage || `Limit of ${config?.max} characters reached`;
    }
    return '';
  },
  isDate: (fieldValue = '', minDate = '') => {
    if (isEmptyDate(fieldValue)) {
      return 'Required field';
    }
    if (isYyyyMmDd(fieldValue)) {
      return '';
    }
    return 'Invalid date';
  },
  minDate: (fieldValue = '', minDate = '') => {
    if (!isYyyyMmDd(fieldValue)) {
      return '';
    }
    if (fieldValue.trim() < minDate) {
      return `Cannot occur before ${minDate.substring(0, 4)}`;
    }
    return '';
  },
  maxDate: (fieldValue = '', maxDate = '') => {
    if (!isYyyyMmDd(fieldValue)) {
      return '';
    }
    if (fieldValue.trim() > maxDate) {
      return `Are you sure you entered your correct Date of Birth ?`;
    }
    return '';
  },
  lettersApostrophesOnly: (fieldValue = '', maxLength = 0) => {
    for (let i = 0; i < disallowedCharsArray.length; i += 1) {
      if (fieldValue.includes(disallowedCharsArray[i])) {
        return `Use letters (a-z) and apostrophes ( ' ) and hyphens ( - ) only`;
      }
    }
    return '';
  },
  digitsOnly: (fieldValue = '', isDigitsOnly) => {
    if (fieldValue.search(/[^0-9]/) >= 0) {
      return `Use digits (0-9) only`;
    }
    return '';
  },
  minMaxDigits: (fieldValue = '', [minDigits, maxDigits] = [5, 7]) => {
    const numDigits = fieldValue.trim().length;
    if (numDigits < minDigits || numDigits > maxDigits) {
      return `Enter between ${minDigits}-${maxDigits} digits`;
    }
    return '';
  },
  email: (fieldValue = '', maxLength = 0) => {
    if (
      // eslint-disable-next-line
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        fieldValue
      )
    ) {
      return `Enter a valid email address`;
    }
    for (let i = 0; i < disallowedEmailCharsArray.length; i += 1) {
      if (fieldValue.includes(disallowedEmailCharsArray[i])) {
        return `Enter a valid email address`;
      }
    }
    return '';
  },
  passwordsMustMatch: (password = '', shouldMatch, confirmPassword = '') => {
    if (password.trim() !== confirmPassword.trim()) {
      return `Passwords entered do not match`;
    }
    return '';
  },
};

export function validate(fieldName = '', fieldValue = '', additionalParam) {
  let errorMessage = '';
  const fieldValidationConfig = allValidationConfig[fieldName] || {};

  // Don't validate optional fields if they're blank
  if (fieldValue === '' && fieldValidationConfig?.required === false) {
    return '';
  }

  Object.keys(fieldValidationConfig).forEach((ruleName) => {
    if (errorMessage) {
      return;
    }
    const ruleValue = fieldValidationConfig[ruleName];
    const validator = validators[ruleName];
    errorMessage = validator(fieldValue, ruleValue, additionalParam);
  });
  return errorMessage;
}
